import { Tooltip } from '~/components';
import { useCurrencyFormat } from '~/hooks';
import React from 'react';

export default function ForecastTooltip({ actual, forecast, currency, metric, children }) {
  const currencyFormat = useCurrencyFormat({ currency });

  const message = `${currencyFormat.format(forecast.forecasted)} forecast (estimate at complete) ${metric} comprised of ${currencyFormat.format(actual)} actual ${metric} plus ${currencyFormat.format(forecast.left)} plan ${metric}.`;

  return (
    <Tooltip placement="top" message={message}>
      {children}
    </Tooltip>
  );
}
